<template>
  <div>
    <div :class="`skeleton d-flex col-md-${col} mb-2`" :style="cssVars"></div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    col: { type: String, default: '12' },
    animationDuration: { type: String, default: '1.7s' },
  },
  computed: {
    cssVars() {
      return {
        '--animation-duration': this.animationDuration,
      }
    },
  },
}
</script>

<style scoped>
.skeleton {
  background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%);
  background-size: 1300px;
  animation: gradient var(--animation-duration) ease infinite;
  border-radius: 3px;
  height: 30px;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: gradient;
}

@keyframes gradient {
  0% {
    background-position: -650px 0;
  }
  100% {
    background-position: 650px 0;
  }
}
</style>
